/**
 * Test for whether to show month first (e.g. MM-DD, vs DD-MM)
 *
 * @param {string} storefront - Current storefront selected
 *
 * @return {Boolean}
 */
export function shouldMonthComeFirst(storefront) {
  return storefront === 'us';
}

/**
 * Get index of default country, based on countryCode
 *
 * @param {String} countryCode - Current countryCode selected
 * @return {Number}
 */
export function getCountryCodeIndex(countryCode, countryContent) {
  countryCode = countryCode === '' || countryCode === null || countryCode === undefined ? '' : countryCode === 'eu' ? 'ES' : countryCode.toUpperCase();

  return countryContent.map(country => {
    return country.value;
  }).indexOf(countryCode);
}
